module.exports = __webpack_public_path__ + "img/bolt-icon.2a91e54e.svg";